import '@bryntum/calendar-thin/locales/calendar.locale.En';
import '@bryntum/calendar-thin/locales/calendar.locale.EnGb';
import '@bryntum/calendar-thin/locales/calendar.locale.De';
import '@bryntum/calendar-thin/locales/calendar.locale.FrFr';
import '@bryntum/calendar-thin/locales/calendar.locale.It';
import '@bryntum/calendar-thin/locales/calendar.locale.Es';
import '@bryntum/calendar-thin/locales/calendar.locale.Ru';
import '@bryntum/calendar-thin/locales/calendar.locale.No';
import '@bryntum/calendar-thin/locales/calendar.locale.Pt';

import { employeeLocaleToBryntumLocale } from './bryntumUtils';

export const mapLocaleToBryntumLocale = (locale: string) => {
  return employeeLocaleToBryntumLocale(locale);
};
